export default __webpack_public_path__ + "_/videos/lootbox/video-csgo-f70e34471a10af064a63e42e64f6bd311af0f48b9bc2a6eaf702af5b048a3901.webm";